/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Pit1_DInputs */

const en_to_yaml_pit1_d = /** @type {(inputs: To_Yaml_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quotes around values like no, yes, off, or 1.10 are load bearing. Removing them to tidy up the file can change a string into a boolean or a version into a truncated number, and the failure often shows up far from the edit. If a quoted scalar looks ugly, leave it ugly.`)
};

const ko_to_yaml_pit1_d = /** @type {(inputs: To_Yaml_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no, yes, off, 1.10 같은 값을 둘러싼 인용부호는 구조적으로 필요한 것입니다. 파일을 깔끔하게 만들려고 제거하면 문자열이 불리언으로, 버전이 잘린 숫자로 바뀔 수 있고, 그 실패는 편집한 곳과 멀리 떨어져서 드러나는 경우가 많습니다. 인용된 스칼라가 보기 나쁘더라도 그대로 두세요.`)
};

const ja_to_yaml_pit1_d = /** @type {(inputs: To_Yaml_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no, yes, off, 1.10 のような値を囲む引用符は構造上必要なものです。ファイルを整えるために取り除くと、文字列が真偽値に、バージョンが切り詰められた数値に変わることがあり、その失敗は編集箇所から遠く離れて現れることが多いです。引用付きスカラーが見苦しくても、そのままにしてください。`)
};

/**
* | output |
* | --- |
* | "Quotes around values like no, yes, off, or 1.10 are load bearing. Removing them to tidy up the file can change a string into a boolean or a version into a tr..." |
*
* @param {To_Yaml_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_pit1_d = /** @type {((inputs?: To_Yaml_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_pit1_d(inputs)
	if (locale === "ko") return ko_to_yaml_pit1_d(inputs)
	return ja_to_yaml_pit1_d(inputs)
});